import React from 'react';
import KexLoadableBlock from '../../Kex/KexLoadableBlock';
import ContentAreaItem from '../../Shared/Models/ContentAreaItem.interface';

type PropType = {
  childItems: ContentAreaItem[];
  isVisible?: boolean;
  nestedContentArea?: boolean;
};

function ContentArea({
  childItems = [],
  isVisible = false,
  nestedContentArea = false,
}: PropType) {
  const renderTopComponents = (
    component: any,
    parentI: any,
    nextComponent: any,
    nestedBlock: any
  ) => {
    return component ? (
      <KexLoadableBlock
        {...component}
        isNested={nestedBlock}
        nextBlockProps={nextComponent}
        key={
          component && component.blockId ? component.blockId + parentI : parentI
        }
        loopIndex={parentI}
        isVisible={!!isVisible}
      >
        {component &&
          component.childItems &&
          component.childItems.map(
            (
              subComponent: React.ReactNode,
              i: number,
              arr: React.ReactNodeArray
            ) =>
              renderTopComponents(
                subComponent,
                parentI + '_' + i,
                arr[i + 1],
                true
              )
          )}
      </KexLoadableBlock>
    ) : (
      <React.Fragment key={parentI} />
    );
  };
  return (
    <>
      {childItems.map((component, i, arr) =>
        renderTopComponents(component, i, arr[i + 1], nestedContentArea)
      )}
    </>
  );
}

export default ContentArea;
